import { BUYER_JOURNEY } from 'constants/types/buyerJourneyTypes';

const initialState: IBuyerJourneyInitialState = {
  contactsOverview: [],
  graphData: [],
  scoringCriteria: [],
  isGraphLoading: false,
  isScoringCriteriaLoading: false,
  isScoringCriteriaUpdated: false,
  isContactsOverviewLoading: false,
  exportPopup: false,
  exportLoading: false,
  trackingId: '',
};

export const buyerJourneyReducer = (state: IBuyerJourneyInitialState = initialState, action: IBuyerJourneyAction) => {
  const newState = { ...state };
  switch (action.type) {
    case BUYER_JOURNEY.GRAPH_DATA_LOAD: {
      newState.isGraphLoading = true;
      return newState;
    }
    case BUYER_JOURNEY.GRAPH_DATA_SUCCESS: {
      newState.isGraphLoading = false;
      const graphData = [...(action.payload as Array<IBuyerJourneyGraphData>)].map((data) => ({
        ...data,
        sources: data.sources.map((source) => ({
          ...source,
          percentage: data.totalContacts ? (source.count / data.totalContacts) * 100 : 0,
        })),
      }));
      newState.graphData = graphData;
      return newState;
    }
    case BUYER_JOURNEY.GRAPH_DATA_RESET: {
      newState.isGraphLoading = false;
      newState.graphData = [];
      return newState;
    }
    case BUYER_JOURNEY.GRAPH_DATA_FAIL: {
      newState.isGraphLoading = false;
      newState.graphData = [];
      return newState;
    }
    case BUYER_JOURNEY.CONTACTS_OVERVIEW_LOAD: {
      newState.isContactsOverviewLoading = true;
      return newState;
    }
    case BUYER_JOURNEY.CONTACTS_OVERVIEW_SUCCESS: {
      newState.isContactsOverviewLoading = false;
      newState.contactsOverview = [...action.payload];
      return newState;
    }
    case BUYER_JOURNEY.CONTACTS_OVERVIEW_RESET: {
      newState.isContactsOverviewLoading = false;
      newState.contactsOverview = [];
      return newState;
    }
    case BUYER_JOURNEY.CONTACTS_OVERVIEW_FAIL: {
      newState.isContactsOverviewLoading = false;
      newState.contactsOverview = [];
      return newState;
    }
    case BUYER_JOURNEY.SCORING_CRITERIA_LOAD: {
      newState.isScoringCriteriaLoading = true;
      return newState;
    }
    case BUYER_JOURNEY.SCORING_CRITERIA_SUCCESS: {
      newState.isScoringCriteriaLoading = false;
      newState.scoringCriteria = [...action.payload];
      return newState;
    }
    case BUYER_JOURNEY.SCORING_CRITERIA_RESET: {
      newState.isScoringCriteriaLoading = false;
      newState.scoringCriteria = [];
      return newState;
    }
    case BUYER_JOURNEY.SCORING_CRITERIA_FAIL: {
      newState.isScoringCriteriaLoading = false;
      newState.scoringCriteria = [];
      return newState;
    }
    case BUYER_JOURNEY.EXPORT_POPUP_OPEN: {
      newState.exportPopup = action.payload;
      return newState;
    }
    case BUYER_JOURNEY.EXPORT_BUTTON_LOAD: {
      newState.exportLoading = action.payload;
      return newState;
    }
    case BUYER_JOURNEY.SET_TRACKING_ID: {
      newState.trackingId = action.payload;
      return newState;
    }
    case BUYER_JOURNEY.RESET_TRACKING_ID: {
      newState.trackingId = '';
      return newState;
    }
    case BUYER_JOURNEY.BUYER_JOURNEY_SCORING_CRITERIA_UPDATED: {
      newState.isScoringCriteriaUpdated = action.payload;
      return newState;
    }
    default: {
      return newState;
    }
  }
};
